import _extends from "@babel/runtime-corejs3/helpers/extends";
import * as React from 'react';
import Base from './base';
var Paragraph = function Paragraph(props) {
  return /*#__PURE__*/React.createElement(Base, _extends({}, props, {
    component: "div"
  }));
};
export default Paragraph;